module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circ-num inlineblock",
    class: _vm.botProp[1] + ' ' + _vm.botProp[2],
    attrs: {
      "aria-label": _vm.aria
    }
  }, [_c('span', {
    staticClass: "always-white"
  }, [_vm._v(_vm._s(_vm.botProp[0]))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-360dc0ed","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/CircleSpan.vue
// module id = 959
// module chunks = 1